import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';

import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import CustomNavbar from '../components/CustomNavbar';
import { authStyles } from './ForgotPasswordPage';

function ResetPasswordPage() {
  const navigate = useNavigate();

  const email = localStorage.getItem('resetEmail') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  /* Simple strength meter: length + variety of character classes */
  const getStrength = (value) => {
    let score = 0;
    if (value.length >= 6) score++;
    if (value.length >= 10) score++;
    if (/[A-Z]/.test(value) && /[a-z]/.test(value)) score++;
    if (/\d/.test(value)) score++;
    if (/[^A-Za-z0-9]/.test(value)) score++;
    return Math.min(score, 4);
  };

  const strength = getStrength(password);
  const strengthMeta = [
    { label: 'Too weak', color: '#ef4444' },
    { label: 'Weak', color: '#f59e0b' },
    { label: 'Fair', color: '#eab308' },
    { label: 'Good', color: '#22c55e' },
    { label: 'Strong', color: '#16a34a' }
  ][strength];

  const resetPassword = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.warning('Password must be at least 6 characters');
      return;
    }

    if (password !== confirm) {
      toast.warning('Passwords do not match');
      return;
    }

    try {
      setLoading(true);

      await axios.post(`${API}/users/reset-password`, {
        email,
        password
      });

      localStorage.removeItem('resetEmail');

      toast.success('Password updated successfully');

      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomNavbar />

      <div className="auth-wrap">
        <Card className="border-0 shadow-lg auth-card">
          <Card.Body className="p-4 p-md-5">
            <div className="text-center mb-4">
              <div className="auth-icon">🔒</div>

              <h3 className="fw-bold mb-2">Reset Password</h3>

              <p className="text-muted mb-0">
                Create a new password for your account. Make it strong and
                something you'll remember.
              </p>
            </div>

            <Form onSubmit={resetPassword}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">New Password</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">🔑</span>

                  <Form.Control
                    type={show ? 'text' : 'password'}
                    placeholder="Enter new password"
                    className="auth-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoFocus
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShow((s) => !s)}
                    aria-label={show ? 'Hide password' : 'Show password'}
                  >
                    {show ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>

                {password && (
                  <div className="mt-2">
                    <div className="auth-strength-track">
                      <div
                        className="auth-strength-fill"
                        style={{
                          width: `${(strength / 4) * 100}%`,
                          background: strengthMeta.color
                        }}
                      />
                    </div>
                    <small
                      className="fw-semibold"
                      style={{ color: strengthMeta.color }}
                    >
                      {strengthMeta.label}
                    </small>
                  </div>
                )}
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label className="fw-semibold">
                  Confirm Password
                </Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">🔑</span>

                  <Form.Control
                    type={show ? 'text' : 'password'}
                    placeholder="Re-enter new password"
                    className="auth-input"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                  />
                </div>

                {confirm && confirm !== password && (
                  <small className="text-danger">Passwords do not match</small>
                )}
              </Form.Group>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Updating...
                  </>
                ) : (
                  'Update Password'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <Link to="/login" className="auth-link">
                ← Back to Login
              </Link>
            </div>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
    </>
  );
}

export default ResetPasswordPage;
